<template>
  <div>
    <h1 class="center-header">Уважаемые клиенты!</h1>
    <p class="text mb-3">
      В связи с проведением технических работ доступ к сервисам АО
      "Татэнергосбыт" ограничен
      <strong> с {{technicalWorkInfo.startAt}} до {{technicalWorkInfo.finishAt}}.</strong>
      Приносим извинения за доставленные неудобства. 

    </p>
    <p class="text mb-3">
            Рекомендуем обновить
      страницу после указанного времени окончания работ.
    </p>
    <p class="text mb-3">
         Вы можете воспользоваться другими способами оплаты ЖКУ и передачи показаний ПУ:
            <ul class="mt-3">
                <li><a href="https://tatenergosbyt.ru/communal/how-pay">Как оплатить ЖКУ</a></li>
                <li><a href="https://tatenergosbyt.ru/supply/uchet/how-send">Как передать показания ПУ</a></li>
                <li><a href="https://tatenergosbyt.ru/about/press/news/kak-oplatit-zhilishchno-kommunalnye-uslugi-bez-komissii/">Как оплатить ЖКУ без комиссии</a></li>
            </ul>
        </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  layout: "guest",
  name: "technical-work",
  data: () => ({
    source: "Guest",
  }),
  computed: {
    ...mapState("guest", ["technicalWorkInfo"]),
  },
  created() {
    let href = window.location.href;
    if (href.includes("?")) {
      let paramsPart = href.split("?")[1];
      this.source = paramsPart.split("=")[1];
    }

    if (this.technicalWorkInfo && this.technicalWorkInfo.isNotReload && this.source !== 'Guest' && this.source !== 'Authorization') {
      this.technicalWorkInfo.isNotReload = false;
    } else {
      this.$store
        .dispatch("guest/getHealth", {
          source: this.source,
          isNotReload: false,
        })
        .then((res) => {
          if (res.success) {
            if (this.source === "LK" || this.source === 'Authorization') this.$router.push({ path: "/" });
            else this.$router.push({ path: "/guest-readings" });
          }
        });
    }
  },
};
</script>

<style scoped>
.center-header {
  text-align: center;
  margin-bottom: 15px;
}
.text {
  margin-left: 10%;
  max-width: 900px;
  margin: 0 auto;
}

a {
  color: orange;
  text-decoration: underline;
  transition: none;
}
a:visited,
a:focus,
a:hover {
  color: orange;
}

@media screen and (max-width: 600px) {
  .center-text {
    max-width: 650px;
  }
}
</style>
